module.exports = __webpack_public_path__ + "img/mov.7ec370d4.svg";